import React from "react";

const ContactoLayout = () => {

    return (
        
        <section className='topic'>
            <h2 id="games"><a href="#games">#</a>Contacto</h2>
            <section class="nes-container is-rounded">
            
                <section class="message -left">
                    <div class="nes-balloon from-left">
                        <p>Hola, si quieres contactarte con nosotros, por favor escribe directamente a alguien del equipo.</p>
                        <p>Ahora, también puedes escribirnos a nuestro correo o twitter y te responderemos a la brevedad posible.</p>
                        <p style={{'textAlign': 'center'}}>
                            <span style={{'whiteSpace':"nowrap"}}>
                                <i class="nes-icon gmail is-small"></i> {" "} 
                                <a 
                                    href="mailto:hablemos@novandi.cl?subject=Consulta NovandiGames" 
                                    target='_blank' 
                                    rel='noreferrer' >
                                        hablemos@novandi.cl
                                </a>
                            </span>
                            {" "}
                            <span style={{'whiteSpace':"nowrap"}}>
                                <i class="nes-icon twitter is-small"></i> {" "}
                                <a href="https://twitter.com/novandigames" 
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="twitter"
                                    >
                                        @novandigames
                                </a>
                            </span>
                        </p>
                    </div>
                    <i class="nes-mario"></i>
                </section>

            </section>
            
        </section>
    );

}

export default ContactoLayout;